module.exports = __webpack_public_path__ + "static/media/lazyaz_app2_preview.9b56f070.jpg";